export default function FormTextArea({
  label, // Label text
  value, // Textarea value
  onChange, // Called with new value string
  placeholder = "", // Placeholder text
  rows = 4, // Number of rows (default: 4)
  maxLength, // Max character length
  hint, // Optional hint text below textarea
  required = true, // Show red asterisk (default: true)
}) {
  return (
    <div className="mb-6">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full px-4 py-2 border border-gray-300 rounded-md"
        rows={rows}
        maxLength={maxLength}
      />
      {hint && <p className="mt-1 text-xs text-gray-500">{hint}</p>}
    </div>
  );
}
